import CONST from '../../../../../includes/primitives/_constant_trion'
export default {
  data: () => ({
    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
    rawData:  [],
    
    current: {SVG: 'LQ'},

    
    canvasForms:  null,

  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },




  methods: {
    set_ColorStyles() {

    }
  }
  
}